@import '../../../constants/screen-width-breakpoints.module.less';
@import '../../../constants/z-index.module.less';
@import '../../../constants/transitions.module.less';
@import '../../../constants/mixins.module.less';

.container {
  position: fixed;
  inset: 0;
  overflow: hidden;
  transition: right @transition-sidebar-shift;
  z-index: @z-drawer;
  .shift-for-sidebar();
}

.canvas {
  background-color: var(--default--background-color--1);
  height: 100%;
  overflow: hidden;
}

.drawer-background {
  position: fixed;
  inset: 0;
  background-color: var(--dark--background-color--2);
  transition: right @transition-sidebar-shift;
  z-index: @z-drawer;
}

.drawer {
  position: fixed;
  inset: 64px 0 0;
  display: flex;
  flex-flow: column nowrap;
  border-radius: 8px 8px 0 0;
  border-width: 1px 1px 0;
  border-style: solid;
  border-color: var(--default--border-color--12);
  overflow: hidden;
  animation: slidein 250ms ease-out;
  transition: right @transition-sidebar-shift;
  z-index: @z-drawer;
  .shift-for-sidebar();
}

@keyframes slidein {
  0% {
    transform: translateY(100%);
  }

  100% {
    transform: translateY(0%);
  }
}
